/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_It_Works__Process_Steps_TitleInputs */

const en_how_it_works__process_steps_title = /** @type {(inputs: How_It_Works__Process_Steps_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Complete Process in 4 Steps`)
};

/**
* | output |
* | --- |
* | "The Complete Process in 4 Steps" |
*
* @param {How_It_Works__Process_Steps_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const how_it_works__process_steps_title = /** @type {((inputs?: How_It_Works__Process_Steps_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_It_Works__Process_Steps_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_how_it_works__process_steps_title(inputs)
});